import React, { useState } from "react";
import { AlertTriangle, X, Mail } from "lucide-react";
import { apiV2Service } from "../services/apiV2Service";
import { showApiMessage } from "../utils/messageHandler";

const EmailVerificationBanner = ({ user }) => {
  const [isResending, setIsResending] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  if (!user || user.emailConfirmed || !isVisible) return null;

  const handleResend = async () => {
    setIsResending(true);
    try {
      // Use the dedicated resend endpoint with the user's username (usually email)
      const username = user.username || user.emailAddress;
      const response = await apiV2Service.resendEmailConfirmation(username);
      showApiMessage(response, "resend verification email");
    } catch (error) {
      showApiMessage(error, "resend verification email");
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-2 flex items-center justify-between shadow-sm animate-in fade-in slide-in-from-top duration-300">
      <div className="flex items-center gap-3">
        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-amber-100 flex items-center justify-center">
          <AlertTriangle className="w-4 h-4 text-amber-600" />
        </div>
        <div>
          <p className="text-sm font-medium text-amber-800">Email not verified</p>
          <p className="text-xs text-amber-700">
            Please check your inbox ({user.emailAddress}) to confirm your account and access all features.
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={handleResend}
          disabled={isResending}
          className="inline-flex items-center px-3 py-1 text-xs font-semibold text-amber-900 bg-amber-200/50 hover:bg-amber-200 rounded-md transition-colors disabled:opacity-50"
        >
          {isResending ? (
            <div className="w-3 h-3 border-2 border-amber-900 border-t-transparent rounded-full animate-spin mr-2" />
          ) : (
            <Mail className="w-3 h-3 mr-2" />
          )}
          Resend Email
        </button>
        <button onClick={() => setIsVisible(false)} className="p-1 text-amber-500 hover:text-amber-700 rounded-md">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default EmailVerificationBanner;
